import { jsx, jsxs } from "react/jsx-runtime";
function WarningIcon() {
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 64 64",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M32 58.6667C39.3637 58.6667 46.0304 55.6819 50.8561 50.8562C55.6819 46.0304 58.6667 39.3638 58.6667 32C58.6667 24.6363 55.6819 17.9696 50.8561 13.1439C46.0304 8.31815 39.3637 5.33337 32 5.33337C24.6363 5.33337 17.9696 8.31815 13.1438 13.1439C8.31812 17.9696 5.33334 24.6363 5.33334 32C5.33334 39.3638 8.31812 46.0304 13.1438 50.8562C17.9696 55.6819 24.6363 58.6667 32 58.6667Z",
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: "5.33333",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32 47.8334C33.8409 47.8334 35.3333 46.341 35.3333 44.5001C35.3333 42.6591 33.8409 41.1667 32 41.1667C30.159 41.1667 28.6666 42.6591 28.6666 44.5001C28.6666 46.341 30.159 47.8334 32 47.8334Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M32 18V35.8333",
                stroke: "white",
                strokeWidth: "4.26667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
export { WarningIcon as default };
